import { NgModule } from '@angular/core';
import { PhoneFilterComponent } from './phone-filter.component';
import { InputsModule } from '@progress/kendo-angular-inputs';

@NgModule({
    imports: [
        InputsModule
    ],
    declarations: [
        PhoneFilterComponent
    ],
    exports: [
        PhoneFilterComponent
    ]
})
export class PhoneFilterModule { }
